import React from 'react';
function EirEmptyCart(props){
    return (      
        <div className="cart__empty__position">           
                <div><div className="cart__empty__icon"></div></div>
                <div className="cart__empty__heading">Looks like your cart is empty</div>
                <div className="cart__empty__subtext">Why not take a look at some of our great bundle offers?</div>
                <div className="cart_empty_button_position">
                    <a href={props.url} className="cart_empty_button">View Offers</a>
                </div>
                            
        </div>
   ); 
}export default EirEmptyCart;